import { useState } from 'react'
import {
	Sheet,
	SheetContent,
	SheetTrigger,
} from '@cocoonspace/ui/components/sheet'

import { CreateEventType } from './event-types/edition/create-event-type'
import type { EditEventTypeFormData } from './event-types/edition/event-type-form'

export const CreateEventTypeAction = ({
	children,
	onSuccess,
	defaultValues,
}: {
	children?: React.ReactNode
	onSuccess?: VoidFunction
	defaultValues?: Partial<EditEventTypeFormData>
}) => {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<Sheet
			open={isOpen}
			onOpenChange={setIsOpen}
		>
			<SheetTrigger asChild>{children}</SheetTrigger>

			<SheetContent className='p-0'>
				<CreateEventType
					defaultValues={defaultValues}
					onSuccess={() => {
						setIsOpen(false)
						onSuccess?.()
					}}
				/>
			</SheetContent>
		</Sheet>
	)
}
